import { render, staticRenderFns } from "./StudyTree.vue?vue&type=template&id=3d55eab2"
import script from "./StudyTree.vue?vue&type=script&lang=js"
export * from "./StudyTree.vue?vue&type=script&lang=js"
import style0 from "./StudyTree.vue?vue&type=style&index=0&id=3d55eab2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports